


















































import Vue from "vue";
import Swiper from "swiper";
import "./swiper.scss";

export default Vue.extend({
  name: "Person",
  data() {
    return {
      spanActiveIndex: 0, //轮播高亮下标
      personInfo: [
        {
          name: "Điêu Thuyền",
          info1:
            'Một trong tứ đại mỹ nhân cổ đại, nhan sắc hoa nhường nguyệt thẹn, dùng "Mỹ nhân kế" giúp nghĩa phụ Vương Doãn ly gián Đổng Trác-Lữ Bố',
          title1: "Kỹ năng chiến đấu: ",
          tit1Info: " Nhất Võ Biền Thiên",
          title2: "Kỹ năng vượt ải:",
          tit2Info: "Điệp Vũ Thiên Nha",
          info2:
            "Tấn công 576, HP 3000, Vật Phòng 72, Pháp Phòng 290, Tư chất 14"
        },
        {
          name: "Gia Cát Lượng",
          info1:
            "Thừa tướng Thục Hán. Giúp Lưu Bị đưa ra nhiều diệu kế. Cúc cung tận tụy vì Thục Hán.",
          title1: "Kỹ năng chiến đấu: ",
          tit1Info: " Bát Quái Nghi Trận",
          title2: "Kỹ năng vượt ải:",
          tit2Info: "Kế Định Càn Khôn",
          info2:
            "Tấn công 480, HP 4224, Vật Phòng 120, Pháp Phòng 210, Tư Chất 1"
        },
        {
          name: "Tào Tháo",
          info1:
            "Nhà quân sự nổi tiếng, trí dũng mưu lược, biết trọng dụng người tài, một đời nam chinh bắc chiến.",
          title1: "Kỹ năng chiến đấu: ",
          tit1Info: "Ỷ Thiên Thần Uy",
          title2: "Kỹ năng vượt ải:",
          tit2Info: "Quân Giáng Thiên Hạ",
          info2:
            "Tấn công 432, HP 5280, Vật Phòng 144, Pháp Phòng 120, Tư Chất 1"
        },
        {
          name: "Lữ Bố ",
          info1:
            "Từng nhiều lần đối đầu với 3 anh em Lưu-Quan-Trương ở Hổ Lao Quan, võ nghệ xứng danh đệ nhất thiên hạ.",
          title1: "Kỹ năng chiến đấu: ",
          tit1Info: "Càn Quét Thiên Quân",
          title2: "Kỹ năng vượt ải:",
          tit2Info: "Chiến Thần Vô Song",
          info2:
            "Tấn Công 504, HP 4560, Vật Phòng 144, Pháp Phòng 150, Tư Chất 1"
        },
        {
          name: "Chân Cơ ",
          info1:
            "Vợ của Tào Phi, mẹ của Tào Duệ. Nhan sắc khuynh quốc khuynh thành. ",
          title1: "Kỹ năng chiến đấu: ",
          tit1Info: "Phong Tuyết Băng Thiên",
          title2: "Kỹ năng vượt ải:",
          tit2Info: "Lạc Thần Giáng Lâm",
          info2:
            "Tấn Công 240, HP 1250, Vật Phòng 30, Pháp Phòng 290, Tư Chất 8"
        },
        {
          name: "Chu Du",
          info1:
            "Danh tướng Đông Ngô, kỳ tài quân sự, đại bại trăm vạn quân Tào tại trận Xích Bích, đặt nền móng tam phân thiên hạ.",
          title1: "Kỹ năng chiến đấu: ",
          tit1Info: "Hỏa Thiêu Xích Bích",
          title2: "Kỹ năng vượt ải:",
          tit2Info: "Phong Hỏa Ngập Trời",
          info2:
            "Tấn Công 240, HP 1250, Vật Phòng 30, Pháp Phòng 290, Tư Chất 14"
        }
      ]
    };
  },
  mounted() {
    // 加载轮播图
    var mySwiper = new Swiper(".swiper-container", {
      autoplay: 2000,
      speed: 1000,
      loop: true,
      autoplayDisableOnInteraction: false,
      pagination: ".pagination",
      grabCursor: true,
      paginationClickable: true
    });
    mySwiper.addCallback("SlideChangeStart", swiper => {
      this.spanActiveIndex = swiper.activeIndex - 1;
      // console.log('>>>>>>>>>>>',this.spanActiveIndex,swiper.activeIndex)
      if (swiper.activeIndex == 7) {
        this.spanActiveIndex = 0;
      }
    });
  }
});
